<template lang="pug">
    #app
        #bg(:class="[background.current,{'-scroll':$store.getters.getScroll}]")
        //- Status
        //- router-view
        Home
</template>

<script>
import Status from "@/components/Status";
import Home from "@/views/Home";
import { setInterval, clearInterval } from "timers";
var countTimer;
export default {
    name: "app",
    components: {
        Status,
        Home
    },
    mounted() {
        this.$store.dispatch("setHeight");
        this.$store.dispatch("setWidth");
        window.addEventListener("resize", this.resize);
        // スクロールしたら値をストアに送る
        window.addEventListener("scroll", () => {
            this.$store.dispatch("setScrollNum");
        });
        this.beforeScroll = window.pageYOffset;
    },
    data() {
        return {
            background: {
                current: "-main",
                main: {
                    pc: "pc_background.png",
                    sp: "mobile_background.png"
                }
            },
            moveCount: 0
        };
    },
    computed: {
        // スクロールの値を常に監視
        scroll() {
            return this.$store.getters.getScrollNum;
        }
    },
    methods: {
        resize() {
            this.$store.dispatch("setHeight");
            this.$store.dispatch("setWidth");
        }
    },
    watch: {
        scroll() {
            // 検索用：スクロールを検知してから元の場所に戻すまでの時間（秒）
            this.moveCount = 5;
            if (!this.$store.getters.getScroll) {
                this.$store.dispatch("setScrollTrue");
                countTimer = setInterval(() => {
                    this.moveCount--;
                    //// console.log(this.moveCount);
                }, 1000);
            }
        },
        moveCount() {
            if (this.moveCount === 0) {
                this.$store.dispatch("setScrollFalse");
                clearInterval(countTimer);
            }
        }
    }
};
</script>

<style lang="scss">
#app {
    > #bg {
        position: fixed;
        top: 0;
        left: 0;
        background-size: cover;
        background-position: top center;
        min-height: 100vh;
        width: 100%;
        z-index: -10;
        transition: 1s;

        &.-main {
            background-image: url("./assets/img/mobile_background.png");
            @media #{$pc} {
                background-image: url("./assets/img/pc_background.png");
            }
        }

        &.-scroll {
            filter: grayscale(100%) brightness(39%);
        }
    }
}
</style>
